import apiClient from "services/apiClient";

async function getUniversalSettings() {
  const url = `/admin/universal-settings`;
  const res = await apiClient.get(url);
  return res.data;
}

export default getUniversalSettings;
